<template>
  <el-dialog v-dialogDrag :visible.sync="roleDialog" :before-close="roleClose" :close-on-click-modal="false"
    :close-on-press-escape="false" :title="roleTitle" width="500px">
    <el-form ref="roleForm" :model="roleForm" :rules="rules" size="small">
      <el-form-item label="请选择专业分类" prop="specId">
        <el-select v-model="roleForm.specId" style="width: 100%" filterable>
          <el-option v-for="(item, specId) in specList" :key="specId" :value="item.specId" :label="item.specName">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="角色名称" prop="roleName">
        <el-input v-model="roleForm.roleName" maxlength="15" show-word-limit />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="roleClose">取 消</el-button>
      <el-button v-preventReClick size="small" type="primary" @click="getRoleContain">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
const newForm = () => ({
  specId: "",
  roleName: ""
});
import priviService from "@/CommonDP/service/privi-service";
import { mapState } from "vuex";
export default {
  props: {
    systemAddOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      roleDialog: false,
      roleTitle: '添加角色',
      roleForm: newForm(),
      rules: {
        roleName: [{ required: true, message: "请输入角色名称", trigger: "blur" }]
      },
      specList: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  methods: {
    showDlg() {
      this.roleDialog = true;
      this.roleForm = newForm();
      if (this.systemAddOption.$isOperation) {
        this.roleForm.specId = this.systemAddOption.id;
      } else this.roleForm.specId = this.systemAddOption.pid;
      this.getPrjSpecList();
    },
    roleClose() {
      this.roleDialog = false;
      this.$refs.roleForm.resetFields();
    },
    // 获取专业
    async getPrjSpecList() {
      const res = await priviService.queryPrjSpecList(this.enterpriseId);
      this.specList = res.data;
    },
    // 项目专业添加自定义角色
    async getRoleContain() {
      await this.$refs.roleForm.validate();
      const {
        roleForm: { specId, roleName },
        enterpriseId
      } = this;
      const params = { specId, roleName, enterpriseId };
      await priviService.addPrjRole(params);
      await this.$message({ type: "success", message: "角色添加成功" });
      await this.roleClose();
      this.$emit("ok");
    }
  }

};
</script>

<style></style>
